import { render, staticRenderFns } from "./MetricsAndLogsSubPanel.vue?vue&type=template&id=3d34b084"
import script from "./MetricsAndLogsSubPanel.vue?vue&type=script&lang=js"
export * from "./MetricsAndLogsSubPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d34b084')) {
      api.createRecord('3d34b084', component.options)
    } else {
      api.reload('3d34b084', component.options)
    }
    module.hot.accept("./MetricsAndLogsSubPanel.vue?vue&type=template&id=3d34b084", function () {
      api.rerender('3d34b084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Logs/MetricsAndLogsSubPanel.vue"
export default component.exports